var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagJersey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8506C24.8366 32.8506 32 25.6871 32 16.8506C32 8.01403 24.8366 0.850586 16 0.850586C7.16344 0.850586 0 8.01403 0 16.8506C0 25.6871 7.16344 32.8506 16 32.8506Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6939 26.593L18.9517 16.8509H18.9516L28.6939 7.1086C28.2737 6.5626 27.8141 6.03729 27.314 5.5371C26.8138 5.03698 26.2886 4.57729 25.7425 4.15723L16.0003 13.8994L16.0003 13.8995L6.25808 4.15723C5.71214 4.57735 5.18677 5.03691 4.68658 5.5371C4.18639 6.03729 3.72677 6.5626 3.3067 7.1086L13.0489 16.8507L13.049 16.8508L3.30664 26.5931C3.72683 27.1391 4.18645 27.6644 4.68652 28.1646C5.1867 28.6647 5.71195 29.1244 6.25802 29.5445L16.0003 19.8023L16.0003 19.8022L25.7425 29.5444C26.2885 29.1243 26.8138 28.6647 27.314 28.1645C27.8142 27.6644 28.2738 27.139 28.6939 26.593Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 5.71995L16.0004 6.41557L18.783 5.71995V3.35476L17.67 3.91126L16.0004 2.2417L14.3308 3.91126L13.2178 3.35476V5.71995Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 5.72021V7.45946C13.2178 9.58946 16.0004 10.2421 16.0004 10.2421C16.0004 10.2421 18.783 9.5894 18.783 7.45946V5.72021H13.2178Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagJersey);
export default __webpack_public_path__ + "static/media/flag_jersey.7b7b66e26af25e8ba111825560b1e8e1.svg";
export { ForwardRef as ReactComponent };